export default __webpack_public_path__ + "static/analysts_Architect_INTJ_introduction-b52f370f1100b0e20cf73f52caf66ebc.svg";